(function() {
    'use strict';

    angular
        .module('app.archivoReloj')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/archivo-reloj',
                config: {
                    templateUrl: 'app/archivoReloj/archivoReloj.html',
                    controller: 'ArchivoReloj',
                    controllerAs: 'vm',
                    title: 'ArchivoReloj'
                }
            },
            {
                url: '/datos-archivo/:tipoPlanillaId?/:planillaId?',
                config: {
                    templateUrl: 'app/archivoReloj/datosArchivoReloj.html',
                    controller: 'DatosArchivoReloj',
                    controllerAs: 'vm',
                    title: 'DatosArchivoReloj'
                }
            }
        ];
    }
})();
